import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { AI_PERSONAS_ACTION_TYPE } from '../actions';

const initialState = {
  aiPersonas: [],
  globalAiPersonas: [],
  securityGroupIdsByPersonaId: {},
};

const aiPersonasReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case AI_PERSONAS_ACTION_TYPE.GET_AI_PERSONAS:
        draft.aiPersonas = payload;
        break;

      case AI_PERSONAS_ACTION_TYPE.GET_AI_PERSONA_BY_ID:
        draft.aiPersonas = state.aiPersonas.some(({ id }) => id === payload.id)
          ? state.aiPersonas.map(persona => (persona.id === payload.id ? payload : persona))
          : [...state.aiPersonas, payload];
        break;

      case AI_PERSONAS_ACTION_TYPE.CREATE_AI_PERSONA:
      case AI_PERSONAS_ACTION_TYPE.CLONE_AI_PERSONA:
        draft.aiPersonas = [...state.aiPersonas, payload];
        break;

      case AI_PERSONAS_ACTION_TYPE.UPDATE_AI_PERSONA:
        draft.aiPersonas = state.aiPersonas.map(persona =>
          persona.id === payload.id ? payload : persona,
        );
        break;

      case AI_PERSONAS_ACTION_TYPE.DELETE_AI_PERSONA:
        draft.aiPersonas = state.aiPersonas.filter(({ id }) => id !== payload);
        break;

      case AI_PERSONAS_ACTION_TYPE.GET_GLOBAL_AI_PERSONAS:
        draft.globalAiPersonas = payload;
        break;

      case AI_PERSONAS_ACTION_TYPE.GET_AI_PERSONA_SECURITY_GROUPS:
      case AI_PERSONAS_ACTION_TYPE.SET_AI_PERSONA_SECURITY_GROUPS:
        draft.securityGroupIdsByPersonaId[payload.id] = payload.securityGroupIds;
        break;

      case AI_PERSONAS_ACTION_TYPE.RESET_AI_PERSONAS_STATE:
      case RESET_STATE:
        return initialState;

      default:
        break;
    }
  });

export default aiPersonasReducer;
